import { POIShape } from './POIShape';
import * as THREE from 'three';
import { AppSettingsData } from '../core/AppSettingsData';
import { SceneSettingsData } from '../core/SceneSettingsData';
import { ThreeGeomFactory } from './ThreeGeomFactory';
import { POI } from '../poi/POI';

export class TriangleShape extends POIShape {

    constructor(
        poi: POI,
        sceneSettings?: SceneSettingsData,
        appSettings?: AppSettingsData
    ) {
        super(poi, sceneSettings, appSettings, {});

        // Listen for geometry-affecting changes
        this.poi.poidata.cornerRadius?.on(() => this.recreateGeometry());
        this.poi.poidata.edgeRadius?.on(() => this.recreateGeometry());
        this.sceneSettings?.geometryResolution.on(() => this.recreateGeometry());
        
        // Material aspect ratio affects the geometry for proper UV mapping
        this.primaryMaterial.aspectRatio.on(() => this.recreateGeometry());
    }

    protected override createGeometry(): THREE.BufferGeometry {
        const size = 1.0; // Base size is always 1, scaling is handled by transform
        const depth = this.poi.poidata.depth?.value ?? 0.1; // Fixed depth for triangle
        const cornerRadius = this.poi.poidata.cornerRadius?.value ?? 0.0;
        const edgeRadius = this.poi.poidata.edgeRadius?.value ?? 0.0;
        const resolution = this.sceneSettings?.geometryResolution.value ?? 1.0;
        
        const relativeCornerRadius = cornerRadius > 0 ? cornerRadius : 0;
        const relativeEdgeRadius = edgeRadius > 0 ? edgeRadius : 0;

        // Use beveled edges if edgeRadius is greater than 0
        if (relativeEdgeRadius > 0) {
            return ThreeGeomFactory.createRoundedTriangleWithBeveledEdges(
                size, 
                size, 
                depth, 
                relativeCornerRadius, 
                relativeEdgeRadius, 
                resolution,
                this.primaryMaterial.aspectRatio.value,
                this.poi.poidata.textureBacksideFlipX?.value ?? true,
                this.poi.poidata.useBacksideSideMaterial?.value ?? false
            );
        } else {
            return ThreeGeomFactory.createRoundedTriangle(
                size, 
                size, 
                depth, 
                relativeCornerRadius, 
                resolution,
                this.poi.poidata.textureBacksideFlipX?.value ?? true,
                this.poi.poidata.useBacksideSideMaterial?.value ?? false
            );
        }
    }
} 